module.exports = __webpack_public_path__ + "img/PC_CN.761c6cdc.svg";